<template>
  <v-dialog
    v-model="dialog"
    max-width="700px"
    persistent
    @input="initializeCroppa"
  >
    <v-card>
      <v-card-title class="primary">
        <v-icon color="my_battery_blue"> mdi-alert-circle-outline </v-icon>
        <span class="text-h6 pl-3 white--text"> Logotipo </span>
      </v-card-title>
      <v-card-text class="py-2 px-5">
        <v-container>
          <v-row>
            <v-col cols="12">
              <p class="pb-0 mb-0">
                Por favor seleccione la imagen que desea que aparezca como
                logotipo para el establecimiento.
              </p>
            </v-col>
            <v-col cols="6">
              <croppa
                class="pb-4"
                v-model="myCroppa"
                :width="300"
                :height="300"
                placeholder="Toca para aquí para buscar."
                placeholder-color="#666666"
                :placeholder-font-size="16"
                :accept="'image/*'"
                prevent-white-space
                canvas-color="transparent"
                :show-remove-button="true"
                remove-button-color="black"
                :show-loading="true"
                :loading-size="50"
                :loading-color="'#606060'"
                :zoom-speed="5"
              >
                <img slot="initial" :src="url" />
              </croppa>
            </v-col>
            <v-col cols="6">
              <p class="pb-0 mb-0 font-weight-bold pb-2 my_battery_blue--text">
                Controles
              </p>
              <ul>
                <li>
                  <strong>Ajustar imagen dentro del cuadro:</strong>
                  <div>
                    Clic izquierdo, movimiento arriba y abajo para posicionar la
                    imagen.
                  </div>
                  <div class="py-3 d-flex justify-center align-center">
                    <v-img
                      contain
                      max-width="35"
                      src="/img/drag-and-drop.png"
                      position="center"
                    >
                    </v-img>
                  </div>
                </li>
                <li>
                  <strong>Alejar o acercar:</strong>
                  <div>
                    Se realiza con el scroll del mouse, hacia arriba y abajo.
                  </div>
                  <div class="py-3 d-flex justify-center align-center">
                    <v-img
                      contain
                      src="/img/scrolling.png"
                      position="center"
                      max-width="35"
                    >
                    </v-img>
                  </div>
                </li>
              </ul>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="pb-5">
        <v-spacer></v-spacer>
        <v-btn @click="close" color="support" outlined> volver </v-btn>
        <v-btn @click="save" elevation="0" color="primary"> Guardar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "DialogoLogo",
  props: {
    initialImage: {
      type: String,
      default: "", // Puede ser una URL o un Base64 ya guardado
    },
  },
  data() {
    return {
      dialog: true,
      image: null,
      changingImage: false,
      url: this.initialImage || "",
      myCroppa: {},
      base64Image: "",
    };
  },
  computed: {
    ...mapState({
      usuario: (state) => state.usuarios.usuario,
    }),
  },
  watch: {
    dialog(val) {
      if (val) {
        this.initializeCroppa();
      } else {
        this.close();
      }
    },
  },
  methods: {
    initializeCroppa() {
      if (this.initialImage) {
        this.myCroppa.importImage(this.initialImage);
      }
    },
    async getImageResize() {
      let hasImage = this.myCroppa.generateDataUrl();
      if (!hasImage) {
        this.$store.dispatch("alerts/setMessage", {
          message: "Debes seleccionar una imagen antes de guardar.",
          type: "info",
        });
        return null;
      }
      return new Promise((resolve) => {
        this.myCroppa.generateBlob(
          (blob) => {
            this.url = URL.createObjectURL(blob);
            this.image = blob;
            this.changingImage = false;

            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => {
              this.base64Image = reader.result;
              resolve({
                url: this.url,
                stringBase64: this.base64Image,
              });
            };
          },
          "image/jpeg",
          0.8
        );
        this.myCroppa.remove();
      });
    },
    async save() {
      const imageData = await this.getImageResize();
      if (imageData) {
        this.$emit("handle", imageData);
      }
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
.croppa-container {
  background-color: #ecf2f9;
  border: 2px solid #afcbf2;
  border-radius: 0px;
  max-height: 300px;
  max-width: 300px;
}

.croppa-container:hover {
  opacity: 1;
  background-color: #e0eeff;
}
</style>
